import { SVGProps } from 'react';
interface BoltProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}
export const BoltGradientBasic = ({
  width = 15,
  height = 15,
  ...props
}: BoltProps) => <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props} data-sentry-element="svg" data-sentry-component="BoltGradientBasic" data-sentry-source-file="Bolt.tsx">
    <rect width={width} height={height} fill="url(#basic-bolt)" rx={5} data-sentry-element="rect" data-sentry-source-file="Bolt.tsx" />
    <path fill="#fff" fillRule="evenodd" d="M9.155 3.525A.5.5 0 0 1 9.5 4v3H12a.5.5 0 0 1 .404.794l-4 5.5A.5.5 0 0 1 7.5 13v-3H5a.5.5 0 0 1-.404-.794l4-5.5a.5.5 0 0 1 .559-.181Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="Bolt.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="Bolt.tsx">
      <linearGradient id="basic-bolt" x1={0} x2={width} y1={0.607} y2={height * 0.929} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="Bolt.tsx">
        <stop stopColor="#24B6EC" data-sentry-element="stop" data-sentry-source-file="Bolt.tsx" />
        <stop offset={1} stopColor="#1DCFAF" data-sentry-element="stop" data-sentry-source-file="Bolt.tsx" />
      </linearGradient>
    </defs>
  </svg>;
export const BoltGradientPro = ({
  width = 15,
  height = 15,
  ...props
}: BoltProps) => <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" {...props} data-sentry-element="svg" data-sentry-component="BoltGradientPro" data-sentry-source-file="Bolt.tsx">
    <rect width={width} height={height} fill="url(#bolt-pro)" rx={5} data-sentry-element="rect" data-sentry-source-file="Bolt.tsx" />
    <path fill="#fff" fillRule="evenodd" d="M9.155 3.525A.5.5 0 0 1 9.5 4v3H12a.5.5 0 0 1 .404.794l-4 5.5A.5.5 0 0 1 7.5 13v-3H5a.5.5 0 0 1-.404-.794l4-5.5a.5.5 0 0 1 .559-.181Z" clipRule="evenodd" data-sentry-element="path" data-sentry-source-file="Bolt.tsx" />
    <defs data-sentry-element="defs" data-sentry-source-file="Bolt.tsx">
      <linearGradient id="bolt-pro" x1={0} x2={width} y1={0.607} y2={height * 0.929} gradientUnits="userSpaceOnUse" data-sentry-element="linearGradient" data-sentry-source-file="Bolt.tsx">
        <stop stopColor="#588AFF" data-sentry-element="stop" data-sentry-source-file="Bolt.tsx" />
        <stop offset={1} stopColor="#A572FF" data-sentry-element="stop" data-sentry-source-file="Bolt.tsx" />
      </linearGradient>
    </defs>
  </svg>;